/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Access_Reason_MutedInputs */



/**
* | output |
* | --- |
* | "muted under Integrations. Unmuting it there lets the agent use it." |
*
* @param {Agent_Access_Reason_MutedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_reason_muted = /** @type {((inputs?: Agent_Access_Reason_MutedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Reason_MutedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unter Integrationen stummgeschaltet. Wird die Stummschaltung dort aufgehoben, kann der Agent sie nutzen.")
	return /** @type {LocalizedString} */ ("muted under Integrations. Unmuting it there lets the agent use it.")
});